// Founder imagery — Priya Kanagaraj's own portraits.
// All files live in /app/frontend/public/images/*.png so they ship with any build
// and have no dependency on any third-party asset host.
//
// To swap a photo: just drop a new PNG with the SAME filename into
// /app/frontend/public/images/ and rebuild. No code changes needed.

export const PRIYA = {
  // Tall portrait — sage green kurta, book-lined interior (Home hero + Services 1:1)
  heroPortrait: "/images/priya-hero.png",
  // Pearl top with "Small Steps. Big Changes." poster (Home story teaser)
  smallSteps: "/images/priya-small-steps.png",
  // White saree, holding a book (About page portrait)
  sareeWithBook: "/images/priya-saree-book.png",
  // White shirt at laptop (Home feedback section)
  laptop: "/images/priya-laptop.png",
  // Lavender shirt, corporate hallway (Services corporate)
  corporate: "/images/priya-corporate.png",
};
